var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("div", { staticClass: "flex-between-center gap-7 mob-flex-column" }, [
      _c("div", { staticClass: "mt-5 wp-50 mob-wp-100" }, [
        _c("div", { staticClass: "has-float-label lineInput" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.order.info2.Nom,
                expression: "order.info2.Nom",
              },
            ],
            staticClass: "form-item",
            attrs: { type: "text", id: "ask-name-input", placeholder: " " },
            domProps: { value: _vm.order.info2.Nom },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.order.info2, "Nom", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "mob-fsize-14", attrs: { for: "ask-name-input" } },
            [_vm._v("Nom")]
          ),
          _vm._v(" "),
          _vm.nom_error
            ? _c(
                "div",
                { staticClass: "color-bo-danger mt-5 whitespace-nowrap" },
                [_vm._v(" " + _vm._s(_vm.nom_error.msg) + " ")]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5 wp-50 mob-wp-100" }, [
        _c(
          "div",
          {
            staticClass: "has-float-label lineInput",
            class: { invalid: _vm.mobile_error },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.order.info2.Mobile,
                  expression: "order.info2.Mobile",
                },
              ],
              staticClass: "form-item",
              attrs: { type: "tel", id: "ask-tel-input", placeholder: " " },
              domProps: { value: _vm.order.info2.Mobile },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.order.info2, "Mobile", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "mob-fsize-14", attrs: { for: "ask-tel-input" } },
              [_vm._v("Mobile")]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.mobile_error
          ? _c("div", { staticClass: "color-bo-danger mt-5" }, [
              _vm._v(_vm._s(_vm.mobile_error.msg) + " "),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.isDeliveryMode(_vm.order)
      ? _c("div", { staticClass: "has-float-label lineInput mt-20" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.order.info2.Company,
                expression: "order.info2.Company",
              },
            ],
            staticClass: "form-item",
            attrs: { type: "text", id: "ask-company", placeholder: " " },
            domProps: { value: _vm.order.info2.Company },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.order.info2, "Company", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "mob-fsize-14", attrs: { for: "ask-company" } },
            [_vm._v("Société")]
          ),
          _vm._v(" "),
          _vm.company_error
            ? _c(
                "div",
                { staticClass: "color-bo-danger mt-5 whitespace-nowrap" },
                [_vm._v(" " + _vm._s(_vm.company_error.msg) + " ")]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "has-float-label lineInput mt-20" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.order.info2.Commentaire,
            expression: "order.info2.Commentaire",
          },
        ],
        ref: "textarea",
        staticClass: "form-item",
        attrs: {
          rows: "2",
          type: "text",
          id: "order-comment",
          placeholder: " ",
          maxlength: "300",
        },
        domProps: { value: _vm.order.info2.Commentaire },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.order.info2, "Commentaire", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "fsize-11 text-italic color-grey6 text-right mt-10" },
      [_vm._v("300 caractères max.")]
    ),
    _vm._v(" "),
    _vm.order.shop.info.seatRequired || _vm.order.shop.info.seatAsked
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "has-float-label lineInput mt-20",
              class: { invalid: _vm.seat_error },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.order.info2.Seat,
                    expression: "order.info2.Seat",
                  },
                ],
                staticClass: "form-item",
                attrs: {
                  id: "seat-text",
                  type: "text",
                  placeholder:
                    _vm.order.shop.info.labels.SeatPlaceholder || " ",
                },
                domProps: { value: _vm.order.info2.Seat },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.order.info2, "Seat", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.order.shop.info.labels.Seat
                ? _c(
                    "label",
                    {
                      staticClass: "mob-fsize-14",
                      attrs: { for: "seat-text" },
                    },
                    [_vm._v(_vm._s(_vm.order.shop.info.labels.Seat))]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.seat_error
            ? _c("div", { staticClass: "color-bo-danger mt-5" }, [
                _vm._v(_vm._s(_vm.seat_error.msg)),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "mob-fsize-14", attrs: { for: "order-comment" } },
      [
        _vm._v("Ajouter un commentaire "),
        _c("i", { staticClass: "fie-icon_help ml-10" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }